import brandLogo from 'assets/logo-cc.png'

const authBrandLogo = () => {
  return brandLogo
}

export default authBrandLogo
